﻿const $ = require('jquery');

$(() => {

    //common
    const cookieConsentChangeHandlers = {
        'webAnalysisGa': {
            onEnabled: () => gTagEnable(),
            onDisabled: () => gTagDisable()
        }
    };
    function getListCookies() {
        let list = document.cookie.split(';').reduce((cookies, cookie) => {
            const [name, value] = cookie.split('=').map(c => c.trim());
            return { ...cookies, [name]: value };
        }, {});
        return list;
    }

    function handleCookieConsentChange(cookie) {
        let keys = Object.keys(cookie.value);
        for (var key of keys) {
            if (cookieConsentChangeHandlers[key]) {
                cookie.value[key] ? cookieConsentChangeHandlers[key].onEnabled() : cookieConsentChangeHandlers[key].onDisabled();
            }
        }
    }

    //gtag
    function getGaCode() {
        return document.getElementsByName('gaCode')[0].attributes['content'];
    }
    let initGaCalled = false;
    function useGtag(cookieConsent) {

        const pathname = document.location.pathname;

        if (isgTagEnabled() && cookieConsent?.webAnalysisGa) {
            ensureInit();
            window.gTag('config', getGaCode(), { 'page_path': pathname });
        }
    }

    function gTagEnable() {
        window[gTagDisableKey()] = false;
        ensureInit();
    }

    function gTagDisable() {
        const domain = getGaCookieDomain(document.location.hostname);

        window[gTagDisableKey()] = true;
        Object.keys(getListCookies())
            .filter(isGaCookie)
            .forEach(cookieName => cookieService.DeleteCookie(cookieName, domain));
    }

    function ensureInit() {
        if (window.gTag && !initGaCalled) {
            window.gTag('js', new Date());
            initGaCalled = true;
        }
    }

    function isGaCookie(cookieName) {
        return /^(AMP_TOKEN|_gid|_ga(t|_.+|c_.+|t_.*)?|_dc_gtm_.*)$/gi.test(cookieName); // https://developers.google.com/analytics/devguides/collection/gtagjs/cookie-usage
    }

    function getGaCookieDomain(hostname) {
        const lastDotIndex = hostname.lastIndexOf('.');
        if (lastDotIndex < 0) {
            return hostname;
        }
        const nextDotIndex = hostname.lastIndexOf('.', lastDotIndex - 1);
        if (nextDotIndex < 0) {
            return `.${hostname}`;
        }
        return hostname.substring(nextDotIndex);
    }

    function isgTagEnabled() {
        return !window[gTagDisableKey()];
    }

    function gTagDisableKey() {
        return `ga-disable-` + getGaCode(); // https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
    }
    //Cookie provider
    let CookieServiceProvider = function () { };
    const STRUCTURE = {
        'required': {
            name: 'required',
            label: 'Erforderlich',
            description: 'Diese Cookies werden für eine reibungslose Funktion unserer Webseite benötigt. Funktional notwendige Cookies sind für die Nutzung unserer Webseite erforderlich. Eine Zustimmung ist nicht notwendig.',
            cookieKeys: ['required'],
            required: true
        },
        'webAnalysis': {
            name: 'webAnalysis',
            label: 'Web-Analyse',
            description: 'Mittels pseudonymisierter Daten von Webseitenutzern kann der Nutzerfluss analysiert und beurteilt werden. Dies gibt uns die Möglichkeit, unsere Webseiteinhalte zu optimieren.',
            cookieKeys: ['webAnalysisGa'],
            required: false
        },
    };
    const COOKIE_CURRENT_VERSION = 1;

    CookieServiceProvider.prototype.GetCookieConsentCookie = function () {
        let name = "CookieConsent=";
        let cookie = CookieServiceProvider.prototype.GetCookieByName(name);
        if (cookie.length > 0) return JSON.parse(cookie);
        let defaultCookie = CookieServiceProvider.prototype.DeclineAllCookieConsentCookie();
        defaultCookie.version = -1;
        return defaultCookie;
    }

    CookieServiceProvider.prototype.GetCookieByName = function (name) {
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    CookieServiceProvider.prototype.DeleteCookie = function (cookieName, domain) {
        let date = new Date();
        date.setTime(date.getTime() + 1000); //set to expire in one second
        document.cookie = cookieName + '=;expires=' + date.toUTCString() + ';path=/;domain=' + domain;
    }

    CookieServiceProvider.prototype.SetCookieConsentCookie = function (cookie) {
        let date = new Date();
        cookie.version = COOKIE_CURRENT_VERSION;
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); //validity one year or 365 days in miliseconds
        let encodedCookie = encodeURIComponent(JSON.stringify(cookie)) + ';expires=' + date.toUTCString() + ';path=/';
        document.cookie = 'CookieConsent=' + encodedCookie;
        handleCookieConsentChange(cookie);
    }

    CookieServiceProvider.prototype.AcceptAllCookieConsentCookie = function () {
        let result = {
            value: {
                required: true,
                webAnalysisGa: true
            },
            version: COOKIE_CURRENT_VERSION
        };
        return result;
    }

    CookieServiceProvider.prototype.DeclineAllCookieConsentCookie = function () {
        let result = {
            value: {
                required: true,
                webAnalysisGa: false
            },
            version: COOKIE_CURRENT_VERSION
        };
        return result;
    }

    CookieServiceProvider.prototype.GetCookieDialogForm = function (cookieConsent) {
        let form = document.createElement('form');
        form.name = 'cookieConsentDialogForm';
        form.classList.add('cookie-consent-dialog-form');
        let table = document.createElement('table');
        table.classList.add('table-large');
        let tableHead = document.createElement('thead');
        let headRow = document.createElement('tr');
        let headToggle = document.createElement('td');
        headToggle.innerHTML = "Aus/Ein";
        let headName = document.createElement('td');
        headName.innerHTML = "Kategorie";
        let headLabel = document.createElement('td');
        headLabel.classList.add('cookie-desc');
        headLabel.innerHTML = "Zweck";
        headRow.appendChild(headToggle);
        headRow.appendChild(headName);
        headRow.appendChild(headLabel);
        tableHead.appendChild(headRow);
        let tableBody = document.createElement('tbody');
        tableBody.classList.add('cookie-consent-dialog-table-body');
        table.appendChild(tableHead);
        table.appendChild(tableBody);
        let cookieStructureKeys = Object.keys(STRUCTURE);
        for (let key of cookieStructureKeys) {
            let row = document.createElement('tr');
            let toggleCol = document.createElement('td');
            let labelCol = document.createElement('td');
            labelCol.classList.add('cookie-label');
            labelCol.innerHTML = STRUCTURE[key].label;
            let descriptionCol = document.createElement('td');
            descriptionCol.classList.add('cookie-description');
            descriptionCol.innerHTML = STRUCTURE[key].description;
            let descRowMobile = document.createElement('tr');
            descRowMobile.classList.add('mobile');
            let descriptionColMobile = document.createElement('td');
            descriptionColMobile.classList.add('cookie-description', 'mobile');
            descriptionColMobile.setAttribute('colspan', 2);
            descriptionColMobile.innerHTML = STRUCTURE[key].description;
            descRowMobile.appendChild(descriptionColMobile);
            let toggle = document.createElement('span');
            toggle.innerHTML = `<label class="switch">
  <input type="checkbox"` + (STRUCTURE[key].required ? 'disabled checked ' : '') + `>
  <span class="slider round"></span>
</label>`;
            toggle.classList.add('toggle');
            let cookieValue = STRUCTURE[key].required;
            for (let cookieKey of STRUCTURE[key].cookieKeys) {
                cookieValue = cookieValue || cookieConsent.value[cookieKey];
            }
            toggle.checked = cookieValue;
            function assignEventListener(element) {
                let cookies = STRUCTURE[key].cookieKeys;
                element.addEventListener('change', function (ev) {
                    for (let cookie of cookies) {
                        cookieConsent.value[cookie] = ev.target.checked;
                    }
                });
            }
            assignEventListener(toggle);
            toggleCol.appendChild(toggle);
            row.appendChild(toggleCol);
            row.appendChild(labelCol);
            row.appendChild(descriptionCol);
            tableBody.appendChild(row);
            tableBody.appendChild(descRowMobile);
        }
        form.appendChild(table);

        return form;
    }

    CookieServiceProvider.prototype.IsValidCookieConsent = function (cookie) {
        return cookie && cookie.version == COOKIE_CURRENT_VERSION && cookie.value && cookie.value.required;
    }
    //cookie banner
    //call init
    function isCookiePolicy(location) {
        return /cookiePolicy/gi.test(location); 
    }
    if (typeof (initCookieConsent) != 'undefined') initCookieConsent();

    let cookieService;
    function initCookieConsent() {
        cookieService = new CookieServiceProvider();
        if (cookieService) {
            let cookie = cookieService.GetCookieConsentCookie();
            if (!isCookiePolicy(window.location.href) && cookie && !cookieService.IsValidCookieConsent(cookie)) {
                document.getElementById('cookieConsentWrap').classList.remove('hidden');
                document.getElementsByTagName('body')[0].classList.add('disable-actions');
                buildForm(cookie);
            }
            useGtag(cookie);

            handleCookieConsentChange(cookie);
            assignCookieDetailsEventListeners(cookie);
            assignButtonListeners(cookie);
        }
    }

    function assignButtonListeners(cookie) {
        document.getElementById('optionsToggle').addEventListener('click', function () { toggleOptions() });
        document.getElementById('saveButton').addEventListener('click', function () { submitCookie(cookie, null) });
        let declineAllButtons = document.getElementsByClassName('declineAllButton');
        for (let btn of declineAllButtons) {
            btn.addEventListener('click', function () { submitCookie(cookie, false) });
        }
        let acceptAllButtons = document.getElementsByClassName('acceptAllButton');
        for (let btn of acceptAllButtons) {
            btn.addEventListener('click', function () { submitCookie(cookie, true) });
        }
    }

    function buildForm(cookie) {
        let form = cookieService.GetCookieDialogForm(cookie);
        let holder = document.getElementById('cookie-form-holder');
        holder.appendChild(form);
    }

    function assignCookieDetailsEventListeners(cookie) {
        let cookieKeys = Object.keys(cookie.value);
        function assignEventListener(element) {
            element.addEventListener('change', function (ev) {
                cookie.value[element.name] = ev.target.checked;
                let toggles = document.getElementsByName(element.name);
                for (let toggle of toggles) {
                    toggle.checked = toggle.value = cookie.value[element.name];
                }
                saveCookieConsentFromDataProtection(cookie);
            });
        }
        for (let key of cookieKeys) {
            let toggles = document.getElementsByName(key);
            for (let toggle of toggles) {
                toggle.checked = toggle.value = cookie.value[key];
                assignEventListener(toggle);
            }
        }
    }

    function refreshCookieDetails(cookie) {
        let cookieKeys = Object.keys(cookie.value);
        for (let key of cookieKeys) {
            let toggles = document.getElementsByName(key);
            for (let toggle of toggles) {
                toggle.checked = toggle.value = cookie.value[key];
            }
        }
    }

    function toggleOptions() {
        document.getElementsByClassName('cookie-options')[0].classList.toggle('hidden');
        document.getElementsByClassName('save-button')[0].classList.toggle('hidden');
        document.getElementsByClassName('chevron')[0].classList.toggle('open');
    }

    function saveCookieConsentFromDataProtection(cookie) {
        document.getElementsByTagName('body')[0].classList.remove('disable-actions');
        document.getElementById('cookieConsentWrap').addEventListener('click', function (ev) {
            document.getElementById('cookieConsentWrap').classList.add('hidden');
        });
        if (cookieService) {
            cookieService.SetCookieConsentCookie(cookie);
        }
    }

    function submitCookie(cookie, acceptAll) {
        document.getElementById('cookieConsentWrap').classList.add('hidden');
        document.getElementsByTagName('body')[0].classList.remove('disable-actions');
        if (acceptAll == true) {
            cookie = cookieService.AcceptAllCookieConsentCookie();
        } else if (acceptAll == false) {
            cookie = cookieService.DeclineAllCookieConsentCookie();
        } else {
            cookie.version = COOKIE_CURRENT_VERSION;
        }
        cookieService.SetCookieConsentCookie(cookie);
        if (cookieService.IsValidCookieConsent(cookieService.GetCookieConsentCookie())) {//check if save completed and cookie was set
            refreshCookieDetails(cookie);
            document.getElementById('cookieConsentWrap').classList.add('hidden');
            document.getElementsByTagName('body')[0].classList.remove('disable-actions');
        }
    }
})
